<template>
  <div class="screen-row flex por" :class="{'show-button': isShow && status}">
    <div class="tar label-box fs16 mr10 flex" v-show="!noLabel">
      <div class="flex jcb aic"
           :style="{width: maxLen + 'em'}">
        <span v-for="(s, j) in (more.length ? '更多筛选' : item.label)" :key="j">{{s}}</span>
      </div>
      <span>：</span>
    </div>
    <div v-if="more.length" class="flex more-list">
      <div v-for="(row, i) in more" :key="i" class="mr15">
        <div class="more-item csp flex aic">
          <span>{{row.text || row.placeholder || row.label}}</span>
          <icon type="ios-arrow-down"/>
          <div class="more-show-list pl10 pr10 abs-c w80 dpn zi10" v-if="row.children && row.children.length">
            <screen-row class="pt10" :value="row.children.find(e => e.id === row.value)" :item="row" no-set-height
                        no-label
                        @change="innerChange($event, row)"></screen-row>
          </div>
        </div>
      </div>
    </div>
    <template v-else-if="item.prop">
      <div class="flex-1 transition ovh"
           :style="{height: noSetHeight || ((status ? domHeight : dfHeight) + 'px')}">
        <div ref="listDom">
          <span v-for="(val, k) in item.children" :key="k" class="dib mr10 fs16 tac box csp mb10"
                @click="value = val" :class="{'active': value.id === val.id}">{{val.name}}</span>
        </div>
      </div>
      <div v-if="isShow && !noSetHeight" class="csp tac more-btn"
           @click="status = !status">
        {{!status ? '更多' : '收起'}}
        <icon :type="!status ? 'ios-arrow-down' : 'ios-arrow-up'"/>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "ScreenRow",
    computed: {
      maxLen() {
        let len = this.more.length ? 4 : 0;
        len = Math.max(len, +this.labelCount || 0, (this.item.label || '').length);
        return ++len;
      },
    },
    props: {
      item: {
        type: Object,
        default() {
          return {
            label: '',
            prop: '',
            value: '',
            children: [],
          };
        },
      },
      value: {
        type: Object,
        default() {
          return {
            id: '',
          };
        },
      },
      labelCount: {
        type: String | Number,
      },
      noLabel: {
        type: Boolean,
        default: false,
      },
      noSetHeight: {
        type: Boolean,
        default: false,
      },
      more: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        dfHeight: 30,
        domHeight: '',
        status: false,
        isShow: false,
      };
    },
    watch: {
      value(val) {
        this.getHeight();
        this.$emit('input', val, this.item);
        this.$emit('change', val, this.item);
      },
      item(val) {
        this.value = {
          id: val.value,
          name: val.text,
        };
      },
    },
    created() {
      this.value = {
        id: this.item.value,
      };
    },
    mounted() {
      this.getHeight();
    },
    methods: {
      innerChange(val, row) {
        row.value = val.id || '';
        row.text = row.value ? val.name : '';
        this.$emit('change', val, row);
      },
      getHeight() {
        this.$nextTick(() => {
          let dom = this.$refs.listDom;
          this.domHeight = dom ? dom.offsetHeight : '';
          this.isShow = this.domHeight > this.dfHeight + 10;
        });
      },
    },
  }
</script>

<style scoped lang="less">
  @height: 30px;
  .screen-row {
    margin-top: 0;
    transition: margin-top .3s;
    &:not(.show-button) {
      + .screen-row {
        margin-top: 10px;
      }
    }
    font-size: 14px;
    .more-btn {
      height: @height;
      line-height: @height;
      color: #0066cc;
    }
    .label-box {
      height: @height;
      line-height: @height;
      color: #999;
    }
    .bold {
      font-weight: bold;
    }
    .df-item-style {
      padding: 0 8px;
      height: @height;
      line-height: @height;
      color: #333;
      border-radius: 2px;
    }
    .box {
      .df-item-style;
      &:hover,
      &.active {
        background-color: #4b98ff;
        color: #fff;
      }
    }
    .more-item {
      .df-item-style;
      border: 1px transparent solid;
      &:hover {
        border-color: #2594ff;
        .more-show-list {
          display: block;
        }
      }
    }
    .more-show-list {
      top: 29px;
      border-radius: 3px;
      border: 1px #2594ff solid;
      background-color: #fff;
    }
  }
</style>